import {
  lazy,
  type ComponentType,
  type LazyExoticComponent
} from 'react';

type ModuleDefault<T> = { default: ComponentType<T> };
type Importer<T> = () => Promise<ModuleDefault<T>>;

export const safeLazy = <T = unknown>(
  importer: Importer<T>,
  retries: number = 2
): LazyExoticComponent<ComponentType<T>> => {
  return lazy(async (): Promise<ModuleDefault<T>> => {
    let attempts = 0;

    while (attempts <= retries) {
      try {
        const module = await importer();
        return module;
      } catch (error) {
        attempts++;

        if (attempts <= retries) {
          await new Promise(resolve => setTimeout(resolve, 1000));
        } else {
          console.error("Failed to load module after retries, reloading...", error);
          window.location.reload();
          return { default: () => null } as ModuleDefault<T>;
        }
      }
    }

    return { default: () => null } as ModuleDefault<T>;
  });
};